// @ts-nocheck
import * as $ from 'jquery';

export class ProductSection {
    public selectedProductTypeId: JQuery;
    public selectedProduct: JQuery;
    public selectedFromZone: JQuery;
    public selectedToZone: JQuery;
    public setCartProductPropertiesCallback: (productTypeId: string, productId: string, zoneType: string,
        zoneFrom: string, zoneTo: string, productTypeMaxCount: number) => void;
    private shouldHideZoneSelectionCallback: (productTypeId: string) => any;
    private apiUrl: string;
    private fixedFromZones: Map<string, string>;
    private hideZones: string[];

    constructor(private container: JQuery, apiUrl: string,
        fixedFromZones: Map<string, string>,
        setCartProductProperties: (productTypeId: string, productId: string, zoneType: string, zoneFrom: string,
            zoneTo: string, productTypeMaxCount: number) => any,
        shouldHideZoneSelection: (productTypeId: string) => any,
        hideZones: string[]) {
        this.apiUrl = apiUrl;
        this.selectedProductTypeId = container.find('#SelectedProductTypeId');
        this.selectedProduct = container.find('#SelectedProductId');
        this.selectedFromZone = container.find('#SelectedFromZone');
        this.selectedToZone = container.find('#SelectedToZone');
        this.fixedFromZones = fixedFromZones;
        this.setCartProductPropertiesCallback = setCartProductProperties;
        this.shouldHideZoneSelectionCallback = shouldHideZoneSelection;
        this.hideZones = hideZones;

        this.initialize();
    }

    initialize(): void {
        this.selectedProductTypeId.on('change', (event) => this.productTypeIdChanged(event));
        this.selectedProduct.on('change', (event) => this.dropdownChange(event));
        this.selectedFromZone.on('change', (event) => this.dropdownChange(event));
        this.selectedToZone.on('change', (event) => this.dropdownChange(event));
    }

    productTypeIdChanged(evt: JQueryEventObject): void {
        const input = this.selectedProductTypeId;
        const dest = this.selectedProduct;

        const productTypeId = input.val();
        const zoneType = input.find(':selected').data('zone-type');
        const productTypeMaxCount = input.find(':selected').data('product-type-max-count');

        this.setCartProductPropertiesCallback(productTypeId, null, zoneType, null, null, productTypeMaxCount);

        if (this.shouldHideZoneSelectionCallback(productTypeId)) {
            let val = this.fixedFromZones.get(productTypeId);
            if (val === undefined) {
                val = '';
            }

            this.selectedFromZone.val(val).trigger('change').prop('disabled', true);
            this.selectedToZone.val('').trigger('change').prop('disabled', true);
            let that = this;
            $(this.hideZones).each(function (e, i) {
                that.selectedFromZone.find('option[value="' + i + '"]').show();
                that.selectedToZone.find('option[value="' + i + '"]').show();
            });
        } else {
            this.selectedToZone.val('').trigger('change').prop('disabled', false);
            this.selectedFromZone.val('').trigger('change').prop('disabled', false);

            let that = this;
            $(this.hideZones).each(function (e, i) {
                that.selectedFromZone.find('option[value="' + i + '"]').hide();
                that.selectedToZone.find('option[value="' + i + '"]').hide();
            });
        }

        let section = this;
        $.ajax({
            url: this.apiUrl + '?productTypeId=' + productTypeId,
            dataType: 'json',
            success: function (data) {
                dest.empty();
                $(data).each(function () {
                    $('<option />', {
                        val: this.id,
                        text: this.profileName
                    }).appendTo(dest);
                });
                section.setCartProductPropertiesCallback(productTypeId, dest.val(), null, null, null, productTypeMaxCount);
            }
        });
    }

    dropdownChange(evt: JQueryEventObject) {
        const productTypeMaxCount = this.selectedProductTypeId.find(':selected').data('product-type-max-count');
        this.setCartProductPropertiesCallback(this.selectedProductTypeId.val(), this.selectedProduct.val(), null,
            this.selectedFromZone.val(), this.selectedToZone.val(), productTypeMaxCount);
    }

    getFriendlyCombination(): string {
        let result = '';

        if (this.selectedProductTypeId.val()) {
            result += this.selectedProductTypeId.find(':selected').text().trim();
        }

        if (this.selectedFromZone.val()) {
            result += `, ${this.selectedFromZone.find(':selected').text().trim()}`;
            if (this.selectedToZone.val() && this.selectedFromZone.val() !== this.selectedToZone.val()) {
                result += ` - ${this.selectedToZone.find(':selected').text().trim()}`;
            }
        }

        if (this.selectedProduct.val()) {
            result += `, ${this.selectedProduct.find(':selected').text().trim()}`;
        }

        return result;
    }

    reset() {
        this.selectedProductTypeId.val('');
        this.selectedFromZone.val('');
        this.selectedToZone.val('');
        this.selectedProduct.empty();
        this.selectedProduct.append('<option value="">' + this.selectedProduct.data('default-choice') + '</option>');

        $('.ticket-type').text('');
        $('.ticket-recipient-type').text('');
        $('.ticket-zone-from').text('');
        $('.ticket-zone-to').text('');
    }
}
